export const WhatsappButton = (props) => {
    const url = (process.env.REACT_APP_FRONTEND_URL || window.location.origin) + `/game/${props.quizId}`;
    const message = encodeURIComponent(`Hey, I just played this hilarious game called 'Kid or Dog' where you guess if a picture shows a kid or a dog! Managed to score ${props.score}%, think you can beat that? ${url}`);
    const whatsappMessage = `https://wa.me/?text=${message}`;

    return (
        <a
            href={whatsappMessage}
            rel="noopener noreferrer"
            className="
                w-10 h-10 rounded-full
                bg-green-500 hover:bg-green-600
                flex items-center justify-center
                transition-colors duration-200
                no-underline
            "
            title="Share on WhatsApp"
        >
            <i className="fa-brands fa-whatsapp text-white text-lg"></i>
        </a>
    );
};
